<script>
export default {
  props: {
    text: {
      type: String,
      default: 'lists: loading items list'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    height: {
      type: String,
      default: null
    }
  }
}
</script>

<template>
  <div class="preloader-wrap top-0 bottom-0 start-0 end-0" :class="`position-${this.position}`" :style="{height: height ? height : 'auto'}">
    <div class="position-absolute start-50 top-50 translate-middle text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="mt-4" v-if="this.text.length > 0">{{ $t( text ) }}</div>
    </div>
  </div>
</template>

<style scoped>
  .import-preloader{
    height: 400px;
  }
</style>